import { app } from "js/namespaces";
import { SideBar, controls } from "js/editor/ui";
import { $ } from "js/vendor";
import { buildVersion, isElectron } from "js/config";
import { Tour } from "js/help/tour";
import isConnected from "js/core/utilities/isConnected";
import { UIController } from "js/editor/dialogs/UIController";
import { ShowOfflineDialog } from "js/react/components/Dialogs/BaseDialog";

export const HelpPanel = SideBar.extend({
    className: "help_panel sidebar",
    type: "HelpPanel",

    UI_ANIMATION_DURATION: 300,

    getTitle: function() {
        return "Help";
    },

    setup: function(options) {
        this.isLibrary = options.isLibrary;
        $(window).on("resize.help", event => this.close(false));
    },

    renderContents: function($contents) {
        $contents.append(controls.createButton(this, {
            label: "Chat with us",
            icon: "chat",
            className: "large_icon",
            callback: () => {
                if (!isConnected.connected) {
                    ShowOfflineDialog();
                    return;
                }
                this.close();
                window.zendeskInit();
                window.zE(() => {
                    window.zE.activate();
                });
            }
        }));

        $contents.append(controls.createButton(this, {
            label: "View FAQ",
            icon: "info",
            className: "large_icon",
            callback: () => {
                if (!isConnected.connected) {
                    ShowOfflineDialog();
                    return;
                }
                window.open("https://beautifulai.zendesk.com/hc/en-us", "_blank", "noopener");
            }
        }));

        $contents.append(controls.createButton(this, {
            label: "Report Issue",
            icon: "bug_report",
            className: "large_icon",
            callback: () => {
                if (!isConnected.connected) {
                    ShowOfflineDialog();
                    return;
                }
                UIController.showFeedbackDialog();
            }
        }));
        $contents.append($.div("build-version", `Build ${buildVersion}`));
    },

    toggle(animate = true) {
        let offset = 0;
        if (!this.isLibrary) {
            offset = 60;
        }

        if (!this.isShowingSideBar) {
            this.$el.clickShield(() => this.close(), true, 49);
            this.$el.velocity({
                translateX: [window.innerWidth - this.$el.outerWidth() - offset, window.innerWidth - offset]
            }, {
                duration: animate ? this.UI_ANIMATION_DURATION : 0,
                complete: event => {
                    this.isShowingSideBar = true;
                    this.open();
                }
            });
        } else {
            this.$el.clickShield(false);
            this.$el.velocity({
                translateX: [window.innerWidth - offset, window.innerWidth - this.$el.outerWidth() - offset]
            }, {
                duration: animate ? this.UI_ANIMATION_DURATION : 0,
                complete: event => {
                    this.isShowingSideBar = false;
                    this.remove();
                }
            });
        }
    },

    close: function(animate = true) {
        app.dialogManager.unregisterDialog(this);
        $(window).off("keydown.sidebar");
        $(window).off("resize.help");
        this.toggle(animate);
    }

});
